package org.ssoft.common.app

import kotlinx.datetime.LocalDateTime

object AppItemQrCode {

    private val dateFormatter by lazy {
        LocalDateTime.Format {
            yearTwoDigits(1970)
            monthNumber()
            day()
            hour()
            minute()
            second()
        }
    }

    /**
     * https://game.screensoft.org/remote/125584srtghb5a4esgawfs1c
     * https://game.screensoft.org/remote/{hash}
     * http://game.screensoft.org/remote/{hash}
     *
     */
    fun generateQr(
        appId: Long,
        appType: Int,
        itemGroupId: Long,
        itemId: Long,
        dt: LocalDateTime
    ): String = buildString {
        append(appType.toString(36))
        append(":")
        append(appId.toString(36))
        append(":")
        append(itemGroupId.toString(36))
        append(":")
        append(itemId.toString(36))
        append(":")
        append(dateFormatter.format(dt))
    }.uppercase()


}